import { memo } from 'react';
import { Legend } from 'recharts';

type RenderCustomLegendProps = {
  fontSize: string;
};

const renderCustomLegend = (props: any) => {
  const { payload, fontSize } = props;
  return (
    <ul style={{ display: 'flex', justifyContent: 'center', listStyle: 'none', padding: 0 }}>
      {payload.map((entry: any, index: number) => (
        <li key={`item-${index}`} style={{ margin: '0 12px', color: entry.color, fontSize: fontSize }}>
          ● {entry.value}
        </li>
      ))}
    </ul>
  );
};

const RenderCustomLegend = ({ fontSize }: RenderCustomLegendProps) => {
  return <Legend content={(props) => renderCustomLegend({ ...props, fontSize })} verticalAlign='bottom' />;
};

export default memo(RenderCustomLegend);
